import React from 'react'
import Fade from 'react-reveal/Fade'

const ContentReveal = ({ children }) => {
    return (
        <Fade bottom distance="20px">
            { children }
        </Fade>
    )
}

export default ContentReveal
